import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00058, P00058Data } from './P00058';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';

export class P0006600 extends IProduct {
  override deviceTableIndex: number = 28;

  override modelIdentifier?: string = 'P00066-00';

  override dataIdentifier?: string = 'P0006600';

  override manufacturerName?: string = 'ACWA';

  data: P00058Data = new P00058Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0006600/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0006600/product_light.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0006600/product_light.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0006600;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0006600?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0006600.tuto.installation.help.title',
      helpSlides: [
        'P0006600.tuto.installation.help.1',
        'P0006600.tuto.installation.help.2',
        'P0006600.tuto.installation.help.3',
        'P0006600.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0006600/installation-1_light.png',
            dark: '/assets/ecosystem/images/products/P0006600/installation-1_dark.png',
          },
          text: 'P0006600.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0006600/installation-2_light.png',
            dark: '/assets/ecosystem/images/products/P0006600/installation-2_dark.png',
          },
          text: 'P0006600.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0006600/installation-1_light.png',
            dark: '/assets/ecosystem/images/products/P0006600/installation-1_dark.png',
          },
          text: 'P0006600.tuto.update.page1',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return new P00058().getCPSConfig();
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return new P00058().getEventProductFunctionalities();
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    return new P00058().getCPSConfigByFonctionnality(functionnality);
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return new P00058().getPropertyForOTAUpdate();
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).pvIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
